import { EmpresaResponse } from "core/resources/types/empresa";
import axios from "infra/http";
import { useQuery } from "react-query";

function useUnidadePessoaJuridicas(id: string, pessoaId?: string | null) {
  return useQuery(
    `/v1/unidades/${id}/pessoas-juridicas/${pessoaId}`,
    async () => {
      const res = await axios.get<EmpresaResponse>(
        `/v1/unidades/${id}/pessoas-juridicas/${pessoaId}`
      );

      return res.data;
    },
    {
      enabled: !!pessoaId,
    }
  );
}

export default useUnidadePessoaJuridicas;
